import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { List, Plus } from "react-bootstrap-icons";
import { Button, Col, Form, Table } from "react-bootstrap";
import NewNumberInput from "../../../Components/NewNumberInput";
import { setDefinedServicesPopup, DeleteDefinedService, saveDefinedService, getServiceDefinedData } from "../../store/api/TaskDetailsApi";
import { setDialog } from '../../store/api/GetAllProduct';
import BihamtaTable from '../../../Components/BihamtaTable';
import Loader from "react-loader-spinner";
import { getStaffShare } from "../../store/api/Services";
import { isWebApp, setErrorDialog } from "../../../store/api/CommonFunctions";
function ServiceDefinedServices(props) {
    const frmDefinedServices = useRef({});
    const serviceDefinedCost = useRef({});
    const [selectedDefinedService, selectDefinedService] = useState({});
    const { fieldList, definedCostList, systemSettings } = useSelector(state => {
        return {
            fieldList: state.UserReducer.pageFieldList,
            definedCostList: state.taskDetails.serviceDefinedCostList,
            systemSettings: state.SystemSettingsReducer.systemSettings
        }
    });
    const { serviceInfo, setServiceInfo, setPopSelectStaff, parentStaffID, pgType } = props;
    const [isPending, setPending] = useState(false);
    const [selectedStaff, setStaffData] = useState(null);
    const [isStaffEmpty, setStaffEmpty] = useState(null);
    const roleList = JSON.parse(localStorage.getItem("RoleList"));
    const showStaffShare = !(Number(serviceInfo.AgencyID > 0) && serviceInfo.ReceptionInAgent.toString().toLowerCase() === "true");
    const [priceValues, setPriceValues] = useState({ TaxAmount: 0, Discount: 0, Cost: 0, PureTotalPrice: 0, Count: 1, TaxPercent: 0, StaffShare: 0 });
    const checkFieldPermission = (fieldName, actionType) => {
        let result = actionType === "Read";;
        let field = fieldList?.find(f => f.PageName === "Service_Defined" && f.Name === fieldName);
        if (actionType === "Read" && field) {
            result = field.IsRead === true;
        }
        if (actionType === "Edit" && field) {
            result = field.IsUpdate === false;
        }
        return result;
    }
    function onDelete(res) {
        serviceInfo.AmountCustomerShouldPay = res.AmountCustomerShouldPay;
        serviceInfo.AmountMainCompanyPays = res.AmountMainCompanyPays;
        serviceInfo.TaxAmount = res.TaxAmount;
        serviceInfo.Discount = res.Discount;
        setServiceInfo({ ...serviceInfo });
    }
    const staffSharesInfo = {
        StaffServiceCostPercentShare: selectedStaff ? (serviceInfo?.ServiceType.toLowerCase() === "repair" ? selectedStaff.StaffRepairCostPercentShare : selectedStaff.StaffInstallCostPercentShare) : serviceInfo.StaffServiceCostPercentShare,
        StaffServiceCostFixAmountShare: selectedStaff ? (serviceInfo?.ServiceType.toLowerCase() === "repair" ? selectedStaff.StaffRepairCostFixAmountShare : selectedStaff.StaffInstallCostFixAmountShare) : serviceInfo.StaffServiceCostFixAmountShare
    }
    function onInputFocus(e) {
        e.target.select();
    }
    const tableColes = [
        { colTitle: "تکنسین", colName: "DefinedStaffName", showInMobile: true },
        { colTitle: "شرح تعرفه", colName: "DefinedDescription", showInMobile: true, colType: "string" },
        { colTitle: "تعداد", colName: "DefinedCount" },
        { colTitle: "قیمت واحد", colName: checkFieldPermission("UnitPrice", "Read") ? "DefinedUnitPrice" : "", colType: "currency" },
        { colTitle: "تخفیف", colName: checkFieldPermission("Discount", "Read") ? "DefinedDiscount" : "", colType: "currency" },
        { colTitle: "مالیات", colName: checkFieldPermission("Tax", "Read") ? "TaxAmount" : "", colType: "currency" },
        { colTitle: "قابل پرداخت", colName: checkFieldPermission("UnitPrice", "Read") ? "PureTotalPrice" : "", colType: "currency" },
        { colTitle: "سهم تکنسین", colName: checkFieldPermission("StaffShare", "Read") ? "DefinedStaffShare" : "", colType: "currency", showCondition: () => showStaffShare },

        { colTitle: "گارانتی", colName: "DefinedHasGuaranty", colType: "boolean" }
    ]

    const tableRowButtons = [
        {
            title: "حذف تعرفه", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                if (serviceInfo?.IsArchive !== true && !serviceInfo?.IsNotLastDuration && !serviceInfo.StoppedInStatus) {
                    dispatch(setDialog({
                        status: 'show',
                        arrayBtn: ['yes', 'no'],
                        dialogTitle: 'حذف تعرفه',
                        dialogText: 'آیا از حذف مطمئن هستید؟',
                        okOperation: DeleteDefinedService(item.ServiceCostID, serviceInfo?.ServiceType, (res) => onDelete(res))
                    }))
                }
            }
        }
    ]
    const dispatch = useDispatch();

    const toCurrency = (name, value) => {
        let el = document.getElementById("comma_" + name);
        if (el) {
            el.setAttribute("comma-value", Number(value).toLocaleString(navigator.language, { minimumFractionDigits: 0 }));
        }
    }
    const saveServiceDefinedCost = () => {
        if (isPending) {
            return;
        }
        if (!selectedDefinedService?.ID) {
            setErrorDialog(dispatch, "تعرفه ای انتخاب نشده است.");
            return;
        }
        Object.assign(serviceDefinedCost.current, priceValues);
        serviceDefinedCost.current.ServiceID = serviceInfo.ServiceID;
        serviceDefinedCost.current.ServiceType = serviceInfo.ServiceType;
        serviceDefinedCost.current.DefinedServiceID = selectedDefinedService.ID;
        if (!serviceDefinedCost.current.Cost) {
            serviceDefinedCost.current.Cost = selectedDefinedService.current?.Cost ?? 0;
        }
        if (!serviceDefinedCost.current.Discount) {
            serviceDefinedCost.current.Discount = 0;
        }
        let staffID = document.getElementById("Defined_StaffID")?.value;
        if (staffID === '') {
            setStaffEmpty(true);
            return;
        }
        else {
            setStaffEmpty(false);
        }
        if (staffID) {
            serviceDefinedCost.current.DefinedStaffID = staffID;
        }
        setPending(true);
        dispatch(saveDefinedService(serviceDefinedCost.current, (res) => {
            setPending(false);
            serviceInfo.AmountCustomerShouldPay = res.AmountCustomerShouldPay;
            serviceInfo.AmountMainCompanyPays = res.AmountMainCompanyPays;
            serviceInfo.TaxAmount = res.TaxAmount;
            serviceInfo.Discount = res.Discount;
            setServiceInfo({ ...serviceInfo });
            setPriceValues({ TaxAmount: 0, Discount: 0, Cost: 0, PureTotalPrice: 0, Count: 1, TaxPercent: 0 });
            selectDefinedService({});
            serviceDefinedCost.current = {};
            frmDefinedServices.current?.reset();
            toCurrency("Discount", 0);
        }));
    }
    function onPriceChanged(name, value) {
        if (!value || value === "") {
            value = 0;
        }
        if (name === "StaffShare" && showStaffShare) {
            setPriceValues({ ...priceValues, StaffShare: Number(value) });
            return;
        }
        priceValues[name] = Number(value);
        if (!priceValues.Count) {
            priceValues.Count = 0;
        }
        if (!priceValues.Discount) {
            priceValues.Discount = 0;
        }
        if (!priceValues.TaxPercent) {
            priceValues.TaxPercent = 0;
        }
        if (!priceValues.Cost) {
            priceValues.Cost = 0;
        }
        if (showStaffShare) {
            priceValues.StaffShare = getStaffShare(staffSharesInfo, "defined", priceValues.Discount, Number(priceValues.Cost) * Number(priceValues.Count), systemSettings, serviceInfo.ReceptionInAgent, serviceInfo.AgencyID);
        }
        priceValues.TaxAmount = (Number(priceValues.Cost) * Number(priceValues.Count) - Number(priceValues.Discount)) * Number(priceValues.TaxPercent) / 100;
        priceValues.PureTotalPrice = Number(priceValues.Cost) * Number(priceValues.Count) - Number(priceValues.Discount) + Number(priceValues.TaxAmount);
        setPriceValues({ ...priceValues })
    }
    function showDefinedModal() {
        dispatch(setDefinedServicesPopup(
            {
                status: 'show',
                productTypeID: serviceInfo?.ProductTypeID,
                pgType: pgType,
                productID: serviceInfo?.ProductID,
                setDefinedServiceData: (item) => {
                    toCurrency("Cost", item.Cost);
                    selectDefinedService(item);
                    onPriceChanged("Cost", item.Cost)
                }
            }));

    }
    useEffect(() => {
        if (Number(serviceInfo?.ServiceID) > 0)
            dispatch(getServiceDefinedData(serviceInfo?.ServiceID, serviceInfo?.ServiceType));
    }, [])
    return (
        <Fragment>
            {(serviceInfo?.IsArchive !== true && !serviceInfo?.isNotLastDuration) &&
                <Fragment>
                    <form ref={frmDefinedServices}>
                        <div className="row">
                            {roleList && roleList.find(s => s === "Reception") && !roleList.find(s => s === "Staff") && !roleList.find(s => s === "Agent") &&
                                <div className='form-group  col-md-3'>
                                    <label>نام تکنسین</label>
                                    <input type='hidden' id="Defined_StaffID" value={selectedStaff ? selectedStaff.ID : serviceInfo?.StaffID ?? ""} readOnly />
                                    <input placeholder='تکنسین را انتخاب کنید' type="text" className='form-control' value={selectedStaff ? selectedStaff.LastName : serviceInfo?.StaffName ?? ""} readOnly />
                                    &nbsp;
                                    <Button className="btn-input-tiny" onClick={() => { setPopSelectStaff({ show: true, onSelect: setStaffData, parentID: parentStaffID }) }}><List size={20} /></Button>
                                    {isStaffEmpty === true && <small className='errors'>تکنسین انتخاب نشده است</small>}
                                </div>
                            }
                            <div className="form-group col-md-3">
                                <input type="hidden" name="DefinedServiceID" readOnly value={selectedDefinedService?.ID ?? 0} definedservices="" />
                                <label>کد و شرح تعرفه</label>
                                <input type="text" className="form-control" name="ItemDesc" definedservices=""
                                    readOnly value={selectedDefinedService?.Description ? selectedDefinedService.Code + "-" + selectedDefinedService.Description : ""} />
                                <Button type="button" className="btn-input-tiny"
                                    onClick={showDefinedModal}><List size={20} /></Button>
                            </div>
                            <div className='form-group  col-md-2'>
                                <label>وضعیت گارانتی: </label>
                                <select className='form-control' name="IsGuaranty" definedservices="" defaultValue={false} onChange={e => serviceDefinedCost.current.IsGuaranty = e.target.value}>
                                    <option value={false} style={{ color: "red" }}>شامل گارانتی نیست</option>
                                    <option value={true} style={{ color: "#008058" }}>شامل گارانتی است</option>
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-md-1">
                                <label>تعداد</label><span style={{ color: "red" }}>*</span>
                                <input type="number" name="Count" className="form-control" defaultValue={1} min={0.1} definedservices="" step={0.1}
                                    onChange={e => onPriceChanged("Count", e.target.value)} onFocus={onInputFocus} />
                            </div>
                            {checkFieldPermission("UnitPrice", "Read") && <div className="form-group col-md-2">
                                <label>قیمت واحد</label>
                                <NewNumberInput inputname="Cost" readonly={checkFieldPermission("UnitPrice", "Edit")} value={priceValues?.Cost ?? 0} minvalue={0} onChange={(e) => { onPriceChanged("Cost", e.target.value) }} customattr={{ definedservices: '' }} />
                            </div>
                            }
                            {checkFieldPermission("Discount", "Read") &&
                                <div className="form-group col-md-2">
                                    <label>تخفیف</label>
                                    <NewNumberInput inputname="Discount" readonly={checkFieldPermission("Discount", "Edit")} defaultValue={0} minvalue={0} customattr={{ definedservices: "" }} onChange={e => onPriceChanged("Discount", e.target.value)} />
                                </div>
                            }
                            {checkFieldPermission("Tax", "Read") &&
                                <Col md={2} className="form-group">
                                    <div style={{ width: "30%", display: "inline-block" }}>
                                        <label className='ellipsisLabel' title='درصد مالیات'>% مالیات</label>
                                        <Form.Control type='number' defaultValue={0} readOnly={checkFieldPermission("Tax", "Edit")} name="TaxPercent"
                                            definedservices="" onChange={(e) => onPriceChanged("TaxPercent", e.target.value)} minvalue={0} style={{ borderRadius: "0px 4px 4px 0px" }} onFocus={onInputFocus} />
                                    </div>
                                    <div style={{ width: "70%", display: "inline-block" }}>
                                        <label>مالیات</label>
                                        <NewNumberInput inputname="TaxAmount" readonly={true} value={priceValues.TaxAmount} style={{ borderRadius: "4px 0px 0px 4px", marginRight: "1px" }} customattr={{ definedservices: "" }} />
                                    </div>
                                </Col>
                            }
                            <Col md={2} className='form-group'>
                                <label>قابل پرداخت: </label>
                                <NewNumberInput readonly={true} value={priceValues.PureTotalPrice} />
                            </Col>
                            {showStaffShare &&
                                <Col md={2} className='form-group'>
                                    <label>سهم تکنسین</label>
                                    <NewNumberInput inputname="StaffShare" readonly={checkFieldPermission("StaffShare", "Edit")} value={priceValues?.StaffShare ?? 0} minvalue={0} onChange={(e) => { onPriceChanged("StaffShare", e.target.value) }} customattr={{ definedservices: '' }} />
                                </Col>
                            }
                        </div>
                    </form>
                    <button type="button" className="btn btn-success btn-block mt-2 group-Btn" onClick={saveServiceDefinedCost} disabled={isPending || serviceInfo.StoppedInStatus}><Plus size={18} />ثبت تعرفه</button>
                </Fragment>
            }
            <BihamtaTable columns={tableColes} dataList={{ Data: definedCostList }} rowButtons={tableRowButtons} />
        </Fragment>
    )
}
export default ServiceDefinedServices;